import {
  createRouter as createTanstackRouter,
  type ParsedLocation,
} from '@tanstack/react-router';

import {
  QueryError,
} from '#components/errors/QueryError'; // Default Error component
import {
  PendingProgress,
} from '#components/ui/progress/PendingProgress'; // Default loading delay component
import {
  routeTree,
} from '#src/routeTree.gen'; // Generated route tree
import {
  NotFoundError,
} from '#src/components/errors/404/NotFoundError';

function getScrollRestorationKey(
  location: ParsedLocation,
): string {
  const scrollByPathRoutes = [
    '/',
    '/mydigitalworkers/',
    '/settings/',
  ];
  return scrollByPathRoutes.includes(location.pathname)
    ? location.pathname
    : location.state.key!;
}

// Create a new router instance
export function createRouter() {
  return createTanstackRouter({
    routeTree,
    context: {
      auth: undefined!, // To be injected on route render (@see src/routes/__root.tsx)
      queryClient: undefined!,
    },
    defaultStructuralSharing: true, // Stable shared router state object references
    defaultPreload: 'intent', // Default method to trigger route preloading
    defaultPreloadDelay: 250, // Default time before route preload is triggered (in milliseconds)
    defaultPreloadStaleTime: 0, // Default time that loader data is considered valid after a route is preloaded or visited. Set to zero to pass all events to Tanstack Query
    defaultErrorComponent: QueryError, // Default fallback component to display loading errors
    defaultPendingComponent: PendingProgress, // Default progressbar component to display during loading delays
    defaultNotFoundComponent: NotFoundError, // Default component to display if a route does not match a valid path
    defaultPendingMs: 250, // Default time before showing progressbar component (in milliseconds)
    defaultPendingMinMs: 500, // Default minimum time to show progressbar component (in milliseconds)
    scrollRestoration: false, // Return to previous scroll position when navigating using browser history
    // getScrollRestorationKey,                  // Function to get a scroll cache key for a given router location
    scrollToTopSelectors: ['#app-shell-main'],
    defaultViewTransition: {
      types: [
        'slide-in-scale-x',
        'slide-out-scale-xy',
      ],
    },
  });
}

// Register the router instance for type safety
export type RouterType = ReturnType<typeof createRouter>;
declare module '@tanstack/react-router' {
  interface Register {
    router: RouterType;
  }
}
